<template>
<EntityReport entity="ReportHazards" />
</template>

<script>
export default {

}
</script>
